<template>
  <div class="multi-pay">
    <label>
      <span>Сумма оплаты по терминалу</span>
      <input
        :value="terminal"
        @input="$emit('update:terminal', Number($event.target.value))"
        type="number"
        min="0"
        step="1"
        inputmode="decimal"
        required
      >
    </label>

    <label>
      <span>Сумма оплаты наличными</span>
      <input
        :value="cash"
        @input="$emit('update:cash', Number($event.target.value))"
        type="number"
        min="0"
        step="1"
        inputmode="decimal"
        required
      >
    </label>

    <label>
      <span>Сумма оплаты переводом</span>
      <input
        :value="cardTransfer"
        @input="$emit('update:cardTransfer', Number($event.target.value))"
        type="number"
        min="0"
        step="1"
        inputmode="decimal"
        required
      >
    </label>

    <p
      class="multi-pay__balance"
      :class="getBalanceClasses"
      aria-live="polite"
    >
      {{ getBalance }}
    </p>
  </div>
</template>

<script>
import { priceToFormat } from '@/helper'

export default {
  name: 'MultiPay',
  props: {
    price: {
      type: Number,
      default: 0
    },
    terminal: {
      type: Number,
      default: 0
    },
    cash: {
      type: Number,
      default: 0
    },
    cardTransfer: {
      type: Number,
      default: 0
    },
  },
  computed: {
    splitTotal () {
      return Number(this.terminal) + Number(this.cash) + Number(this.cardTransfer)
    },
    splitValid () {
      return this.splitTotal === this.price
    },
    getBalance () {
      return this.splitValid
        ? 'Сумма совпадает с суммой к оплате'
        : `Распределено ${priceToFormat(this.splitTotal)} из ${priceToFormat(this.price)}`
    },
    getBalanceClasses () {
      return { 'is-balanced': this.splitValid }
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
